<template>
  <div>
    <el-form-item label="Tekst" :error="errors[addLanguageSuffix('text')]">
      <wysiwyg-input v-model="form[addLanguageSuffix('text')]" />
    </el-form-item>
  </div>
</template>
<script>
export default {
  props: ['form', 'errors']
}
</script>
<style lang="scss" scoped></style>
